import {WithStyles, withStyles} from '@material-ui/core/styles';
import {PropsWithChildren} from 'react';

import {groupOnDesktopStyles} from './groupOnDesktopStyles';

const GroupOnDesktop = (props: PropsWithChildren<WithStyles>) => (
	<section className={props.classes.root}>{props.children}</section>
);

export default withStyles(groupOnDesktopStyles)(GroupOnDesktop);
